import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NoRoute from './app/pages/404';
import ROUTES from './routes';
import Home from './app/pages/Home';
import Activity from './app/pages/Activity';

const App = () => {
  return (
    <main>
      <BrowserRouter>
        <div>
          <Routes>
            <Route element={<Home />} path={ROUTES.ROOT} />
            <Route element={<Activity />} path={ROUTES.ACTIVITY} />
            <Route element={<NoRoute />} path="*" />
          </Routes>
        </div>
      </BrowserRouter>
    </main>
  );
};

export default App;
